import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShipCaseService {
  private apiUrl = '/shipcases';
  private apiSpringUrl = '/spring/shipcases';
  private apiDeleteUrl = '/spring/shipcases/delete';
  private apiCheckDeleteUrl = '/spring/shipcases/checkdelete';

  constructor(
    private http: HttpService) { }
    
  post(jsonData: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}`;
    return this.http.post(url, jsonData);
  }

  checkDelete(
    updprogramCd: string,
    selectItems: object[]
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiCheckDeleteUrl}`;
    const jsonInput = {
      updprogramCd: updprogramCd,
      selectItems: selectItems
    };
    return this.http.post(url, jsonInput);
  }

  delete(
    updprogramCd: string,
    selectItems: object[]
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiDeleteUrl}`;
    const jsonInput = {
        updprogramCd: updprogramCd,
        selectItems: selectItems
    };
    return this.http.post(url, jsonInput);
  }

  put(
    shipcaseId: number,
    shipcaseNr: number,
    carrierCd: string,
    reqnoCd: string,
    deliunitpriceNr: number,
    delipriceNr: number,
    delichargememoTx: string,
    cancelFl: number,
    notinvoiceFl: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${shipcaseId}`;
    const jsonInput = {
      shipcaseNr: shipcaseNr,
      carrierCd: carrierCd,
      reqnoCd: reqnoCd,
      deliunitpriceNr: deliunitpriceNr,
      delipriceNr: delipriceNr,
      delichargememoTx: delichargememoTx,
      cancelFl: cancelFl,
      notinvoiceFl: notinvoiceFl,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/ship-case/ship-case.service.ts